module.exports = __webpack_public_path__ + "img/Trampoline-Gymnastics.27c68950.png";